module.exports = __webpack_public_path__ + "files/d13e27aebb614a5559f07708e410e43f.png";